import { Link } from "react-router-dom";
import { articlesData } from "@/mocks/articlesData";

const cardImages = [
  "https://readdy.ai/api/search-image?query=Fashion%20guide%20concept%20with%20sneakers%20and%20clothing%20swatches%20on%20light%20mint%20green%20surface%2C%20editorial%20photography%2C%20bright%20natural%20light%2C%20clean%20composition&width=500&height=400&seq=article-card-img-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Colorful%20retro%20sneakers%20arranged%20in%20circle%20on%20white%20marble%20surface%2C%20product%20photography%2C%20vibrant%20studio%20lighting%2C%20clean%20geometric%20composition&width=500&height=400&seq=article-card-img-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Three%20oversized%20hoodies%20in%20neutral%20tones%20draped%20on%20light%20oak%20wooden%20background%2C%20editorial%20fashion%20photography%2C%20warm%20afternoon%20light%2C%20cozy%20minimalist&width=500&height=400&seq=article-card-img-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Magnifying%20glass%20examining%20clothing%20fabric%20texture%20on%20light%20grey%20desk%2C%20conceptual%20photography%2C%20soft%20studio%20lighting%2C%20verification%20and%20authentication%20theme&width=500&height=400&seq=article-card-img-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20neatly%20on%20light%20beige%20surface%2C%20editorial%20product%20photography%2C%20bright%20natural%20light%2C%20logistics%20and%20delivery%20theme&width=500&height=400&seq=article-card-img-05&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Shield%20icon%20with%20shopping%20bag%20and%20checkmark%20on%20light%20lavender%20surface%2C%20conceptual%20photography%2C%20soft%20diffused%20lighting%2C%20safety%20and%20protection%20theme&width=500&height=400&seq=article-card-img-06&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Assortment%20of%20folded%20cotton%20t-shirts%20in%20pastel%20rainbow%20colors%20on%20white%20surface%2C%20product%20photography%2C%20bright%20daylight%2C%20clean%20minimalist&width=500&height=400&seq=article-card-img-07&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Denim%20jacket%20and%20bomber%20jacket%20flatlay%20on%20light%20concrete%20textured%20surface%2C%20editorial%20fashion%20photography%2C%20soft%20directional%20lighting%2C%20clean%20composition&width=500&height=400&seq=article-card-img-08&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Tote%20bag%20backpack%20and%20accessories%20flatlay%20on%20light%20blush%20pink%20surface%2C%20editorial%20product%20photography%2C%20soft%20natural%20lighting%2C%20modern%20composition&width=500&height=400&seq=article-card-img-09&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Open%20laptop%20with%20fashion%20items%20and%20coffee%20on%20light%20wooden%20desk%2C%20lifestyle%20photography%2C%20warm%20natural%20lighting%2C%20welcoming%20beginner%20friendly&width=500&height=400&seq=article-card-img-10&orientation=landscape",
];

export default function ArticleCards() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-medium text-foreground-500 tracking-widest uppercase mb-3">
            Latest Guides
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            SEO Buying Guides{" "}
            <span className="font-heading italic text-accent-500">&amp; Seller Tips</span>
          </h2>
          <p className="text-base text-foreground-600 mt-4 max-w-2xl mx-auto">
            Explore our in-depth articles covering every aspect of using AcBuy spreadsheets — from sneaker finds to safety guides, shipping tips, and beginner walkthroughs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-8">
          {articlesData.slice(0, 8).map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-white border border-background-200/70 transition-colors hover:border-accent-300 cursor-pointer"
            >
              <div className="h-48 md:h-52 relative overflow-hidden">
                <img
                  src={cardImages[idx]}
                  alt={article.title}
                  title={article.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="text-xs text-foreground-400">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {articlesData.slice(8).map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-white border border-background-200/70 transition-colors hover:border-accent-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 h-48 sm:h-auto relative overflow-hidden flex-shrink-0">
                <img
                  src={cardImages[8 + idx]}
                  alt={article.title}
                  title={article.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 sm:p-6 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="text-xs text-foreground-400">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}